export const handleError = (message, error) => {
  if (error?.response) {
    /*
     * The request was made and the server responded with a
     * status code that falls out of the range of 2xx
     */
    if (error.response.data) {
      let data = error.response.data;
      if (data.detail) {
        if (Array.isArray(data.detail)) {
          data.detail.forEach((obj) => {
            let key = Object.keys(obj)[0];
            let value = obj[key];

            message.error(`${key}: ${value}`);
          });
        } else if (typeof data.detail === 'object') {
          let key = Object.keys(data.detail)[0];
          let value = data.detail[key];

          message.error(`${key}: ${value}`);
        } else {
          message.error(data.detail);
        }
      } else {
        message.error(data.message ? data.message : data.error);
      }
    } else if (error.response.status === 401) {
      window.location.reload();
    }
  } else if (error?.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js

    message.error('Request Error');
  } else {
    // Something happened in setting up the request that triggered an Error
    message.error(error?.message);
  }
};
